import { useState } from "react";
import DefaultButton from "../Buttons/Default";
import DefaultModal from "./Default";
import { API_URL } from "../../utils/constants";
import { toast } from "react-toastify";

function DeletePropertyModal({isOpen, toggle, onSuccess, propertyId}) {
  const [destroyLoading, setDestroyLoading] = useState(false);

  const destroy = () => {
    setDestroyLoading(true);
    fetch(API_URL+'/user/properties/destroy/'+propertyId, {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })
    .then(response => response.json())
    .then(data => {
      if(data.success) {
        toast.success('تم حذف الإعلان بنجاح');
        onSuccess();
        toggle();
      }
    })
    .catch(error => {
      console.error('Error:', error);
    })
    .finally(() => {
      setDestroyLoading(false);
    });
  }

  return(
    <DefaultModal
      isOpen={isOpen}
      toggle={toggle}
      size="md"
      title="هل تريد حذف هذا الإعلان؟"
    >
      <p className="text-center text-danger mb-3">
        *ملاحظة اذا تم الغاء هذا الاعلان , لن يتم ارجاع لك المبلغ المدفوع لتنزيل الاعلان و العدد الاعلانات المتبقية لك كما هي
      </p>
      <div className="text-center">
        <DefaultButton 
          color="danger" 
          className="me-3 px-4" 
          onClick={destroy}
          loading={destroyLoading}
          disabled={destroyLoading}
        >
          نعم
        </DefaultButton>
        <DefaultButton 
          color="danger" 
          className="px-4" 
          outline 
          onClick={toggle}
        >
          لا
        </DefaultButton>
      </div>
    </DefaultModal>
  );
}

export default DeletePropertyModal;